import { IndicatorBadge } from 'core/Indicators';

export const menu = {
  to: '/dashboard',
  label: 'Dashboard',
  icon: 'house' as const,
  children: [
    { to: '/dashboard/campaigns', label: 'Campaigns' },
    { to: '/dashboard/summary', label: 'Summary' },
    {
      to: '/dashboard/tasks',
      label: 'Tasks',
      suffix: <IndicatorBadge counter="late_tasks" />,
    },
    {
      to: '/dashboard/tickets',
      label: 'Ticket',
      suffix: <IndicatorBadge counter="open_tickets" />,
    },
    {
      to: '/dashboard/calendar',
      label: 'Calendar',
      suffix: <IndicatorBadge counter="calendar_events" />,
    },
  ],
};
